module.exports = __webpack_public_path__ + "dace05921238e4ba03600e3c67e5384a.svg";